// src/pages/Home.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPopularMovies } from "../services/movieApi";
import MovieList from "../components/MovieList";
import "./Home.scss";

const Home = () => {
    const navigate = useNavigate();
    const [popularMovies, setPopularMovies] = useState([]);
    const [currentPage, setCurrentPage] = useState(null);
    const [totalPages, setTotalPages] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [loadingPopularMovies, setLoadingPopularMovies] = useState(false);
    const { pageNumber } = useParams();

    useEffect(() => {
        // Fetch popular movies when the component mounts
        const fetchPopularMovies = async () => {
            try {
                setLoadingPopularMovies(true);
                const data = await getPopularMovies(pageNumber);
                setPopularMovies(data.results);
                setCurrentPage(data.page);
                setTotalPages(data.total_pages);
                setLoadingPopularMovies(false);
            } catch (error) {
                console.error("Error fetching popular movies:", error);
            }
        };

        fetchPopularMovies();
    }, [pageNumber]);

    let prevPage = currentPage - 1;
    let nextPage = currentPage + 1;

    const handleNextPageReq = () => {
        if (nextPage <= totalPages) {
            pageReq(nextPage);
        }
    };

    const handlePrevPageReq = () => {
        if (prevPage > 0) {
            pageReq(prevPage);
        }
    };

    const pageReq = async (page) => {
        try {
            navigate(`/movies/page/${page}`);
        } catch (error) {
            console.error("Error changing page: ", error);
        }
    };

    const handleSearchTerm = (event) => {
        setSearchTerm(event.target.value);
    };
    const handleSearchSubmit = () => {
        navigate(`/movies/search/${searchTerm}/page/1`);
    };

    return (
        <div className="home layout">
            <div className="title-search">
                <h1>Popular Movies</h1>
                <form typeof="submit" onSubmit={handleSearchSubmit}>
                    <input
                        type="text"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={handleSearchTerm}
                    />
                </form>
            </div>
            {loadingPopularMovies ? (
                <p>Loading...</p>
            ) : (
                <>
                    <MovieList movies={popularMovies} />
                    <div className="pagination">
                        <button
                            className={`prev ${
                                prevPage === 0 ? "noclick" : ""
                            }`}
                            onClick={handlePrevPageReq}
                        >
                            Prev
                        </button>
                        <button className="pagination-button">
                            {currentPage}
                        </button>
                        <button
                            className={`next ${
                                nextPage === totalPages + 1 ? "noclick" : ""
                            }`}
                            onClick={handleNextPageReq}
                        >
                            Next
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default Home;
